import { IGroupConfigurationData } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

export class RemoveCommentsTransformer extends BaseJsonTransformer {
    async before(json: IGroupConfigurationData): Promise<void> {
        // remove all comments
        json.comments = [];
    }
}